import React from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useSettings } from "../lib/queries";

export default function WhatsAppFab() {
  const { data: settings } = useSettings();
  const phone = settings?.whatsapp || "+905337819108";
  const num = phone.replace(/[^0-9]/g, "");
  return (
    <motion.a
      data-testid="whatsapp-fab"
      href={`https://wa.me/${num}`}
      target="_blank"
      rel="noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 20 }}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_0_30px_rgba(37,211,102,0.45)] hover:scale-110 transition-transform"
    >
      <MessageCircle size={22} />
      <span className="absolute inset-0 rounded-full border border-white/20 animate-ping" />
    </motion.a>
  );
}
